
  
  export default {
    name: "hubspotmeet",
    props: {
      content: Object
    }
  }
  
  